import React from 'react';
import { BRAND, isBrandOV, isMarketGB } from '../../../constants/main';
import { ColorSelectStyledAC } from './AC/ColorSelectStyled.AC';
import { ColorSelectStyledAP } from './AP/ColorSelectStyled.AP';
import { ColorSelectStyledDS } from './DS/ColorSelectStyled.DS';
import { ColorSelectStyledOV } from './OV/ColorSelectStyled.OV';
import { ColorSelectStyledOVGB } from './OV/GB/ColorSelectStyled.OV.GB';
import { ColorSelectStyled } from './ColorSelectStyled';
import { SC } from '../../../styles/theme';

export type ColorSelectProps = SC & {};

const EngineSelect = (props: ColorSelectProps) => {
    if (isBrandOV) return isMarketGB ? <ColorSelectStyledOVGB {...props} /> : <ColorSelectStyledOV {...props} />;
    if (BRAND === 'AC') return <ColorSelectStyledAC {...props} />;
    if (BRAND === 'AP') return <ColorSelectStyledAP {...props} />;
    if (BRAND === 'DS') return <ColorSelectStyledDS {...props} />;
    return <ColorSelectStyled {...props} />;
};

export default EngineSelect;
